const MODULE_NAME = "MANAGE_TENANTS_";
const FETCH_TENANT_STARTED = MODULE_NAME + "FETCH_SINGLE_STARTED";
const FETCH_TENANT_COMPLETED = MODULE_NAME + "FETCH_SINGLE_COMPLETED";
const FETCH_TENANTS_COMPLETED = MODULE_NAME + "FETCH_COMPLETED";
const FETCH_TENANTS_STARTED = MODULE_NAME + "FETCH_STARTED";
const REINDEX_TENANT_STARTED = MODULE_NAME + "REINDEX_STARTED";
const REINDEX_TENANT_COMPLETED = MODULE_NAME + "REINDEX_COMPLETED";
const UPDATE_TENANT_STARTED = MODULE_NAME + 'UPDATE_TENANT_STARTED';
const UPDATE_TENANT_COMPLETED = MODULE_NAME + 'UPDATE_TENANT_COMPLETED';

export {
  FETCH_TENANT_STARTED,
  FETCH_TENANT_COMPLETED,
  FETCH_TENANTS_COMPLETED,
  FETCH_TENANTS_STARTED,
  REINDEX_TENANT_STARTED,
  REINDEX_TENANT_COMPLETED,
  UPDATE_TENANT_STARTED,
  UPDATE_TENANT_COMPLETED
};
